import React, { useMemo } from 'react';

import { Badge, ListItemButton } from '@mui/material';
import { blue } from '@mui/material/colors';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link, useLocation } from 'react-router-dom';

export interface IDrawerItemProps {
  title: string;
  url: string;
  batchCount?: number;
  useBatch?: boolean;
  icon: React.ComponentType<any>;
}

export const DrawerItem = (props: IDrawerItemProps) => {
  const location = useLocation();
  const isActive = useMemo(
    () => location.pathname === props.url || location.pathname.startsWith(props.url + '/'),
    [location.pathname, props.url],
  );

  return (
    <ListItemButton
      key={props.title}
      component={Link as any}
      to={props.url}
      selected={isActive}
      sx={{ backgroundColor: isActive ? blue[50] : 'white' }}
    >
      <ListItemIcon>
        {props.useBatch ? (
          <Badge badgeContent={props.batchCount} color="primary">
            {React.createElement(props.icon)}
          </Badge>
        ) : (
          <>{React.createElement(props.icon)}</>
        )}
      </ListItemIcon>
      <ListItemText primary={props.title} />
    </ListItemButton>
  );
};
